import { CheckboxGroup } from "react-aria-components";

import { Checkbox } from "#components/Checkbox";
import { ProviderIcon } from "#components/ProviderIcon";
import {
  DEFAULT_PROVIDERS,
  formatProvider,
  isProvider,
  type Provider,
} from "#components/ProviderIcon/formatProvider";
import { cn } from "#utils";

export interface ProviderSelectBoxProps {
  providers?: readonly Provider[];
  selectedProviders: Provider[];
  onSelected: (providers: Provider[]) => void;
  className?: string;
}

export function ProviderSelectBox({
  providers = DEFAULT_PROVIDERS,
  selectedProviders,
  onSelected,
  className,
}: ProviderSelectBoxProps) {
  return (
    <div className={cn("flex flex-col gap-y-3", className)}>
      {/* "Select all" lives outside the group (not part of its value set) */}
      <Checkbox
        className="flex items-center gap-2"
        isSelected={
          selectedProviders.length === providers.length &&
          providers.length > 0 &&
          selectedProviders.every((p) => providers.includes(p))
        }
        onChange={(isSelected) => onSelected(isSelected ? Array.from(providers) : [])}
      >
        All Providers
      </Checkbox>

      <CheckboxGroup
        aria-label="Provider selection"
        onChange={(value) => onSelected(value.filter(isProvider))}
        value={selectedProviders}
      >
        <div className="flex gap-x-8">
          {providers.map((provider) => {
            return (
              <Checkbox key={`provider-select-box-${provider}`} value={provider}>
                <ProviderIcon provider={formatProvider(provider)} />
              </Checkbox>
            );
          })}
        </div>
      </CheckboxGroup>
    </div>
  );
}
